import React, { useEffect, useState } from "react";
import SideBar from "./side-nav-bar";
import NavBar from "./nav-bar";
import Dark from "./dark";


const NavBarWithMenuIcons = () => {
  const [Icons, setIcon] = useState(false);

  const [menuIcon, setMenuIcon] = useState(false);

  const [closeIcon, setCloseIcon] = useState(false);

  const [light, setLight] = useState(false);

  const [dark, setDark] = useState(false);

  return (
    <>
      <header>
        <div className="nav-container">
          <div className="nav-container-wrapper">
            <div className="icons">
              <span
                className="open"
                onClick={() => {
                  setIcon(!Icons);
                  setMenuIcon(!menuIcon);
                  setCloseIcon(!closeIcon);
                }}
              >
                {menuIcon || <i className="ri-menu-line"></i>}
              </span>
              <span
                className="close"
                onClick={() => {
                  setIcon(!Icons);
                  setMenuIcon(!menuIcon);
                  setCloseIcon(!closeIcon);
                }}
              >
                {menuIcon && <i className="ri-close-fill"></i>}
              </span>
            </div>

            <div>{Icons && <MobileSideBar />}</div>

            <div className="search-container-toggle-container">
              <div className="theme-toggle">
                <span
                  className="light-toggle"
                  onClick={() => {
                    setLight(!light);
                    setDark(!dark);
                  }}
                >
                  {light || <i className="ri-sun-fill"></i>}
                </span>
                <span
                  className="dark-toggle"
                  onClick={() => {
                    setLight(!light);
                    setDark(!dark);
                  }}
                >
                  {dark && <i className="ri-moon-fill"></i>}
                </span>
              </div>
            </div>
 
            <div className="login">
              <button>Login</button>
              <i className="ri-map-pin-user-line"></i>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

const MainNavBar = ({movies, setMovies}) => {

  console.log(movies)


  return (
    <>
      <div className="nav-container">
        <Dark/> 
        <NavBar/>
        <div className="login" style={{fontSize:'1rem', cursor:'pointer'}}>
          <button style={{fontSize:'1rem', cursor:'pointer'}}>Login</button>
          <i className="ri-contacts-fill"></i>
        </div>
      </div>
    </>
  );
};

const MobileSideBar = () => {
  return (
    <>
      <header>
        <div className="mobile-nav">
          <nav className="side-nav-container">
            <ul className="links">
              <h3>Categories</h3>
              <li>
                <i></i>
                <h3>Popular</h3>
              </li>
              <li>
                <i></i>
                <h3>Top Rated</h3>
              </li>
              <li>
                <i></i>
                <h3>Upcoming</h3>
              </li>
              <h3>Genre</h3>
              <li>
                <i></i>
                <h3>Upcoming</h3>
              </li>
              <li>
                <i></i>
                <h3>Upcoming</h3>
              </li>
              <li>
                <i></i>
                <h3>Upcoming</h3>
              </li>
              <li>
                <i></i>
                <h3>Upcoming</h3>
              </li>
              <li>
                <i></i>
                <h3>Upcoming</h3>
              </li>
              <li>
                <i></i>
                <h3>Upcoming</h3>
              </li>
            </ul>
          </nav>
        </div>
      </header>
    </>
  );
};

const DestopSideBar = ({movies, setMovies}) => {

  return (
    <>
      <SideBar {...movies} movies ={movies}/>
      <MainNavBar movies ={movies} setMovies={setMovies}/>
    </>
  );
};

const ScreenFit = ({movies, setMovies}) => {
  const [size, setSize] = useState(window.innerWidth);

  const adjustSize = () => {
    setSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", adjustSize);

    return () => {
      window.removeEventListener("resize", adjustSize);
    };
  });

  if (size < 3000 && size > 750) {
    return <DestopSideBar movies={movies} setMovies={setMovies}/>;
  }
  return <NavBarWithMenuIcons />;
};

export default ScreenFit;
